/* eslint-disable @typescript-eslint/no-explicit-any */
import { Reducer } from 'redux';
import { mailsSaga } from './sagas';
import questionSlice, { NOTIFICATION_KEY_IN_STORE } from './slice';

export class MailModule {
	getRootKeyInStore(): string {
		return NOTIFICATION_KEY_IN_STORE;
	}

	getReducers(): Reducer {
		return questionSlice.reducer;
	}

	getSagas(): () => Generator<any, void, any> {
		return mailsSaga;
	}
}

export const moduleInstance = new MailModule();
